// toastUtils.js
import { toast } from 'react-toastify';

export const showToast = (message, type = "info", options = {}) => {
  const baseOptions = {
    autoClose: 8000,
    ...options,
  };

  let customClass = ""; // Initialize custom class for each toast

  switch (type) {
    case "success":
      customClass = "toast-message toast-success";
      toast.success(message, { ...baseOptions, className: customClass });
      break;
    case "error":
      customClass = "toast-message toast-error";
      toast.error(message, { ...baseOptions, className: customClass });
      break;
    case "warn":
      customClass = "toast-message toast-warn";
      toast.warn(message, { ...baseOptions, className: customClass });
      break;
    case "info":
    default:
      customClass = "toast-message toast-info";
      toast.info(message, { ...baseOptions, className: customClass });
      break;
  }
};
